import { css } from '@/styled-system/css';

export const container = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});

export const group = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const groupTitle = css({
  margin: 0,
  color: 'text.neutral',
  fontSize: 'body',
  fontWeight: 'bold',
  lineHeight: 'body',
});

export const detailList = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
  margin: 0,
});

export const detailRow = css({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 'micro.default',
  md: {
    gridTemplateColumns: 'max-content 1fr',
    gap: 'tighter',
  },
});

export const label = css({
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const value = css({
  margin: 0,
  color: 'text.neutral',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});

export const mlsHeader = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
});

export const mlsLogo = css({
  maxWidth: '100%',
  objectFit: 'contain',
});

export const disclaimerText = css({
  margin: 0,
  color: 'text.subtle',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
});
